import { Component, OnInit, Input } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/interval";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.css"]
})
export class AlertComponent implements OnInit {
  @Input() Show: boolean = true;
  @Input() Success: boolean;
  @Input() Msg: string;
  count: Observable<number>;
  constructor() {}

  ngOnInit() {
    this.count = Observable.interval(1500);
    this.count.subscribe(next => {
      if (next > 4) {
        this.Show = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/alert/alert.component.ts